import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import style from "./Note.module.scss";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
  Input,
  Button,
  Table,
} from "reactstrap";
import { FormattedDate, FormattedTime } from "react-intl";
import { CircularProgress, OrderInlineDetail } from "../..";
import LaddaButton, { SLIDE_LEFT } from "react-ladda";
import { localDateTime } from "../../../utils/Helper";

const Note = ({
  open,
  order,
  orderId,
  onNoteRequest,
  onAddRequest,
  onRemoveRequest,
  closeModalNote,
  dispatch,
}) => {
  const [note, setNote] = useState("");
  const [notes, setNotes] = useState(null);
  const [loading, setLoading] = useState(true);

  const componentWillReceiveProps = (nextProps, nextState) => {
    const { orderId } = nextProps;

    if (orderId && !notes) {
      onNoteRequest({ orderId }).then((response) => {
        setLoading(false);
        setNotes(response.response.notes);
      });
    }
  };

  const toggle = () => {
    dispatch(closeModalNote());
    setLoading(true);
    setNotes(null);
  };

  const addNote = () => {
    onAddRequest({ orderId, note: { text: note } }).then((response) => {
      setNote("");
      setNotes((prevNotes) => {
        return [...prevNotes, response.response.note];
      });
    });
  };

  const deleteNote = (noteDate) => {
    onRemoveRequest({ orderId, noteDate }).then((response) => {
      const filteredNotes = notes.filter((item) => item.createdAt !== noteDate);
      setNotes(filteredNotes);
    });
  };

  const onChangeNote = (e) => {
    setNote(e.target.value);
  };

  if (!open) {
    return null;
  }

  return (
    <div>
      <Modal isOpen={open} toggle={toggle} className={style.modal}>
        <ModalHeader toggle={toggle}>
          Order note
          <OrderInlineDetail order={order} />
        </ModalHeader>
        <ModalBody style={{ padding: "10px 8px" }}>
          <Container>
            <Row>
              <Col xs="12" style={{ textAlign: "center" }}>
                <Input
                  style={{ marginBottom: "10px" }}
                  type="textarea"
                  rows="2"
                  placeholder="Note"
                  value={note}
                  onChange={onChangeNote}
                />

                <LaddaButton
                  className="btn btn-ladda btn-primary"
                  loading={loading}
                  disabled={note === ""}
                  onClick={addNote}
                  data-style={SLIDE_LEFT}
                >
                  {"Confirm"}
                </LaddaButton>
              </Col>
            </Row>
            <h5 className={style.subtitle}>Notes</h5>
            {loading ? (
              <CircularProgress />
            ) : (
              <Table responsive size="sm" className={style.tableNote}>
                <thead></thead>
                <tbody>
                  <NotesRows notes={notes} delete={deleteNote} />
                </tbody>
              </Table>
            )}
          </Container>
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

const NotesRows = (props) => {
  if (!props.notes.length) {
    return (
      <tr>
        <td colSpan="3" style={{ textAlign: "center", padding: "10px" }}>
          <h5 style={{ textAlign: "center" }}>No Notes</h5>
        </td>
      </tr>
    );
  }

  return props.notes.map((note) => {
    return (
      <tr key={`note-${note.createdAt}`}>
        <td>
          <span className={style.user}>{note.createdBy}</span>
        </td>
        <td>
          <small color="secondary">
            <FormattedDate value={localDateTime(note.createdAt)} />{" "}
            <FormattedTime value={localDateTime(note.createdAt)} hour12={false} />
          </small>
          <br />
          <p className={style.detail}>{note.text}</p>
        </td>
        <td>
          <Button
            onClick={() => props.delete(note.createdAt)}
            className={style.iconDelete}
            color="danger"
            size="sm"
          >
            <i className="fa fa-trash-o"></i>
          </Button>
        </td>
      </tr>
    );
  });
};

export default Note;
